module.exports = __webpack_public_path__ + "static/media/cross.26bacd49.svg";